import script from "./landing.vue?vue&type=script&setup=true&lang=js"
export * from "./landing.vue?vue&type=script&setup=true&lang=js"

import "./landing.vue?vue&type=style&index=0&id=123e8ebe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-123e8ebe"]])

export default __exports__